import { Navigate, Outlet } from 'react-router-dom';

import type { Permission } from '../../../../backend/src/auth/permissions/permission';
import { useUserContext } from '@/Contexts/User';
import { useHasPermission } from '@/hooks/useHasPermission';

/** Prevents platform pages and their data queries from mounting without an eligible permission. */
export function PlatformPermissionRoute({ permissions }: { permissions: Permission[] }) {
  const { isLoaded } = useUserContext();
  const { hasPermission } = useHasPermission();
  if (!isLoaded) return null;
  if (!permissions.some(hasPermission)) return <Navigate to="/matters" replace />;
  return <Outlet />;
}
